// router/index.js
import { createRouter, createWebHistory } from 'vue-router'

// 静态路由（所有用户可见）
const constantRoutes = [
  {
    path: '/',
    component: () => import('@/views/login/LoginPage.vue')
  },
  {
    name: 'Home',
    path: '/Home',
    redirect: '/Home/kongzhitai', // 自动重定向到默认子路由
    component: () => import('@/views/home/Home.vue'),
    children: [
      {
        name: "控制台",
        path: '/Home/kongzhitai',
        component: () => import('@/views/kongzhitai/kongzhitai.vue'),
      },
      {
        name: "仪表盘",
        path: '/Home/yibiaopan',
        component: () => import('@/views/yibiaopan/yibiaopan.vue'),
      },
      {
        name: "装车任务",
        path: '/Home/zcrw',
        component: () => import('@/views/zcrw/zcrw.vue'),
      },
      {
        name: "设备管理",
        path: '/Home/sbgl',
        component: () => import('@/views/sbgl/sbgl.vue'),
      },
      {
        name: "设备维护",
        path: '/Home/sbwh',
        component: () => import('@/views/sbwh/sbwh.vue'),
      },
      {
        name: "车辆管理",
        path: '/Home/clgl',
        component: () => import('@/views/clgl/clgl.vue'),
      },
      {
        name: "物料管理",
        path: '/Home/wlgl',
        component: () => import('@/views/wlgl/wlgl.vue'),
      },
      {
        name: "报表管理",
        path: '/Home/bbgl',
        redirect: '/Home/bbgl/zcxltj', // 默认重定向到装车效率统计
        children: [
          {
            name: "装车效率统计",
            path: '/Home/bbgl/zcxltj',
            component: () => import('@/views/bbgl/zcxltj.vue'),
          },
          {
            name: "装车故障统计",
            path: '/Home/bbgl/zcgztj',
            component: () => import('@/views/bbgl/zcgztj.vue'),
          }
        ]
      },
    ]
  },
  //   {
  //     path: '/404',
  //     component: () => import('@/views/404.vue')
  //   }
]

const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes
})


export default router